(function (angular) {
  "use strict";

  var IMAGE_ITEM_HOVER_TRANSITION_DURATION_MS = 250;
  var ACCESSORIES_WRAPPER_SCROLL_OFFSET_PX = 10;

  angular.module("Toyota.Legacy").directive("tyLegacyAccessoriesCarousel", [
    "galleryModule",
    "linkToSlide",
    "$rootScope",
    function (galleryModule, linkToSlide, $rootScope) {
      return {
        link: function () {
          function init() {
            attachEvents();
            galleryModule.init();
            linkToSlide.init();

            // Resize Corolla Iframe on Hatch/Sedan Switch
            window.resizeIframe = function () {
              angular.element(".corolla iframe").toggleClass("sized");
            };
          }

          function attachEvents() {
            /*
             * Add jQuery thumbnail rollover animation
             * Check to see if we are on a touch device or not
             */
            var isTouch = window.ontouchstart || navigator.msMaxTouchPoints > 0;

            if (!isTouch) {
              angular.element(".gallery-image-item").hover(
                function () {
                  angular.element(this).find(".caption").fadeIn(IMAGE_ITEM_HOVER_TRANSITION_DURATION_MS);
                },
                function () {
                  angular.element(this).find(".caption").fadeOut(IMAGE_ITEM_HOVER_TRANSITION_DURATION_MS);
                }
              );
            } else {
              angular.element(".gallery-image-item .caption").show();
            }

            // Scroll to the top of the accessories wrapper on click
            angular
              .element(".accessories-item")
              .find(".gallery-image-item")
              .on("click", function () {
                angular.element(".gallery-image-item.active").removeClass("active");
                angular.element(this).addClass("active");
                angular.element("html,body").animate({
                  scrollTop:
                    angular.element(".accessories-wrapper .container").offset().top -
                    ACCESSORIES_WRAPPER_SCROLL_OFFSET_PX,
                });
              });

            // Scroll to the top of the accessories wrapper on click
            angular
              .element(".gallery-items-pane")
              .find(".gallery-item")
              .on("click", function () {
                angular.element(".gallery-item.active").removeClass("active");
                angular.element(this).addClass("active");
                angular.element("html,body").animate({
                  scrollTop:
                    angular.element(".gallery-player-pane.active").offset().top - ACCESSORIES_WRAPPER_SCROLL_OFFSET_PX,
                });
              });

            // init everything
            $rootScope.$on("slide-to/callback", anchorDirect);
          }

          function anchorDirect(msg, slideToData) {
            // Display wanted tab
            if (slideToData.tab) {
              angular.element('.nav-pills a[href="#' + slideToData.tab + '"]').tab("show");
            }

            var $tab = angular.element("#" + slideToData.tab);

            // trigger click on element
            if (slideToData.element) {
              $tab
                .find(
                  '.gallery-item[data-item-id="' +
                    slideToData.element +
                    '"]:visible, .accessories-item[data-item-id="' +
                    slideToData.element +
                    '"]:visible'
                )
                .find("a")
                .trigger("click");
            }
          }

          init();
        },
      };
    },
  ]);
})(window.angular);
